"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeOnPaymentAuthorizedGoogle = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("../..");
const types_1 = require("../../types");
function braintreeOnPaymentAuthorizedGoogle(paymentData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return __awaiter(this, void 0, void 0, function* () {
        const { email, shippingAddress, paymentMethodData } = paymentData;
        const { info, description } = paymentMethodData;
        const { billingAddress } = info;
        const error = {
            reason: src_1.braintreeConstants.GOOGLEPAY_ERROR_REASON_PAYMENT,
            intent: src_1.braintreeConstants.GOOGLEPAY_INTENT_PAYMENT_AUTHORIZATION,
            message: ''
        };
        const googlePaymentInstance = (0, src_1.getBraintreeGooglePayInstanceChecked)();
        const { nonce } = yield googlePaymentInstance.parseResponse(paymentData);
        const formattedShippingAddress = (0, src_1.formatBraintreeShippingAddressGoogle)(shippingAddress);
        const formattedBillingAddress = (0, src_1.formatBraintreeShippingAddressGoogle)(billingAddress);
        const isSameAddress = (0, src_1.isObjectEquals)(formattedShippingAddress, formattedBillingAddress);
        const customerResult = yield (0, src_1.callGuestCustomerEndpoint)(formattedBillingAddress.first_name, formattedBillingAddress.last_name, email !== null && email !== void 0 ? email : '');
        if (!customerResult.success) {
            error.message = (_b = (_a = customerResult.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : 'There was an unknown error while validating your customer information.';
            return {
                transactionState: src_1.braintreeConstants.GOOGLEPAY_TRANSACTION_STATE_ERROR,
                error
            };
        }
        const shippingAddressResponse = yield (0, src_1.callShippingAddressEndpoint)(formattedShippingAddress, false);
        if (!shippingAddressResponse.success) {
            error.reason = src_1.braintreeConstants.GOOGLEPAY_ERROR_REASON_SHIPPING;
            error.message = (_d = (_c = shippingAddressResponse.error) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : 'There was an unknown error while validating your shipping address.';
            return {
                transactionState: src_1.braintreeConstants.GOOGLEPAY_TRANSACTION_STATE_ERROR,
                error
            };
        }
        const billingAddressResponse = yield (0, src_1.callBillingAddressEndpoint)(formattedBillingAddress, !isSameAddress);
        if (!billingAddressResponse.success) {
            error.message = (_f = (_e = billingAddressResponse.error) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : 'There was an unknown error while validating your billing address.';
            return {
                transactionState: src_1.braintreeConstants.GOOGLEPAY_TRANSACTION_STATE_ERROR,
                error
            };
        }
        const taxResponse = yield (0, checkout_frontend_library_1.setTaxes)(types_1.API_RETRY);
        if (!taxResponse.success) {
            error.message = (_h = (_g = taxResponse.error) === null || _g === void 0 ? void 0 : _g.message) !== null && _h !== void 0 ? _h : 'There was an unknown error while calculating the taxes.';
            return {
                transactionState: src_1.braintreeConstants.GOOGLEPAY_TRANSACTION_STATE_ERROR,
                error
            };
        }
        const { public_id: gatewayPublicId } = (0, src_1.getBraintreeGoogleCredentialsChecked)();
        const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
        const { order_total } = (0, checkout_frontend_library_1.getApplicationState)();
        const payment = {
            token: nonce,
            gateway_public_id: gatewayPublicId,
            currency: currencyCode,
            amount: order_total,
            display_string: description
        };
        const paymentResult = yield (0, checkout_frontend_library_1.addPayment)(payment, types_1.API_RETRY);
        if (!paymentResult.success) {
            error.message = (_k = (_j = paymentResult.error) === null || _j === void 0 ? void 0 : _j.message) !== null && _k !== void 0 ? _k : 'There was an unknown error while processing your payment.';
            return {
                transactionState: src_1.braintreeConstants.GOOGLEPAY_TRANSACTION_STATE_ERROR,
                error
            };
        }
        (0, src_1.orderProcessing)();
        return { transactionState: src_1.braintreeConstants.GOOGLEPAY_TRANSACTION_STATE_SUCCESS };
    });
}
exports.braintreeOnPaymentAuthorizedGoogle = braintreeOnPaymentAuthorizedGoogle;
